import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import defaultUserPic from '../../assets/user.svg.js';

var _templateObject, _templateObject2, _templateObject3;
var BaseAvatar = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n\n  @media (max-width: 991px) {\n    width: 45px;\n    height: 45px;\n  }\n"])));
var AvatarFrame = styled(BaseAvatar)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  background-image: ", ";\n"])), "url(".concat(defaultUserPic, ")"));
var Avatar = styled(BaseAvatar)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-image: ", ";\n"])), function (props) {
  return "url(".concat(props.src, ")");
});
var Avatar$1 = (function (_ref) {
  var src = _ref.src;
  return /*#__PURE__*/React__default.createElement(AvatarFrame, {
    className: "text-center"
  }, src ? /*#__PURE__*/React__default.createElement(Avatar, {
    alt: "member avatar",
    src: src
  }) : null);
});

export { Avatar$1 as default };
